module.exports = __webpack_public_path__ + "static/img/cover-photo.3ddec50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/album/cover-photo/cover-photo.jpg
// module id = Q5+9
// module chunks = 43